// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'objektiv', 'objektiv Fallback', Objektiv, sans-serif"},"className":"__className_191c7b","variable":"__variable_191c7b"};